/* External */
import { useCallback, useState } from 'react';

export default function useIsReadyToPlay() {
  const [isReadyToPlay, setIsReadyToPlay] = useState(false);

  const handleReadyToPlay = useCallback(() => {
    setIsReadyToPlay(true);
  }, []);

  const resetIsReadyToPlay = useCallback(() => {
    setIsReadyToPlay(false);
  }, []);

  return { isReadyToPlay, resetIsReadyToPlay, handleReadyToPlay };
}
